import classnames from 'classnames'
import { ToastContentProps } from 'react-toastify'

import { ToastColor, ToastIcon, ToastMessageType } from './const'

interface ToastProps extends Partial<ToastContentProps> {
  variant: ToastMessageType
  headline: string
  text?: string
  action?: {
    label: string
    onClick: () => void
  }
}
export const Toast = ({
  variant,
  headline,
  text,
  action,
  closeToast,
}: ToastProps) => {
  return (
    <div
      className={classnames(
        `toast show border-top-${ToastColor[variant]} bg-light show`,
      )}
    >
      <div className="toast-body">
        <button className="btn-close" onClick={() => closeToast!()}></button>
        <div className="toast-message">
          <div className="toast-group">{ToastIcon[variant]}</div>
          <div className="toast-group">
            <h5>{headline}</h5>
            {text && <p className="mb-0">{text}</p>}
            {action && (
              <button
                onClick={() => {
                  action.onClick()
                  closeToast?.()
                }}
                className="btn btn-link p-0 text-decoration-underline"
                style={{ fontSize: '14px' }}
              >
                {action.label}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
